import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PasswordStrengthBar from 'react-password-strength-bar';
import { error } from '../../hooks/global/ToastAlert';
import { useResetPassword } from '../../hooks/auth/Users';
import { useParams, useLocation } from 'react-router-dom';
import LanguagesSelector from '../../components/public/LanguagesSelectorLogin';
import { useGetAvailableTranslation } from '../../hooks/global/Languages';

export default function PasswordResetPage() {
    const { t, i18n } = useTranslation();

    const [resetSuccess, setResetSuccess] = useState(false);
    const [password, setPassword] = useState("");
    const [inputType, setInputType] = useState("text");
    const [score, setScore] = useState(0);
    const { resetToken } = useParams();
    const location = useLocation();

    const { mutate } = useResetPassword();
    const languages = useGetAvailableTranslation();

    // Extract the 'l' parameter from the URL and set the language
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const lng = params.get('l');
        if (lng) {
            i18n.changeLanguage(lng.toUpperCase());
        }
    }, [location.search, i18n]);

    const handleResetPasswordClick = (event) => {
        event.preventDefault();
        if(score >= 3){
            mutate({ resetToken, password, lng: i18n.language }, {
                onSuccess: (data) => {
                    if(data) {
                        setResetSuccess(true);
                    }
                },
                onError: (err) => {
                    error(err.response.data, 3000, "top-center");
                }
            });
        } else {
            error(t("toast.simPass"), 3000, "top-center");
        }
    }

    return (
        <div className="container container-relative adminLogIn" tabIndex="0">
            <LanguagesSelector lang={languages} />
            <div id="adminLogin">
                <div className="adminLoginWrap">
                    {resetSuccess ? (
                        <div className="row">
                            <div className="adminLoginForm adminLoginResetDone">
                                <div className="col-xs-12 adminLoginHeader text-center clearifix">
                                    <h2>{t("login.passCh")}</h2>
                                    <p>{t("login.vis")}</p>
                                </div>
                                <div className="col-xs-12 adminLoginBack text-center clearifix">
                                    <a href="/admin/login">« {t("login.toLogin")}</a>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <form className="adminLoginForm adminLoginMain">
                                <div className="col-xs-12 adminLoginHeader text-center clearfix">
                                    <h2>{t("login.resPass")}</h2>
                                </div>
                                <div className="col-xs-12 adminLoginInput adminLoginInputPassword clearfix" style={{padding:"0px 15px"}}>
                                    {inputType === "text" ? (
                                        <a className="showPasswordEye showPasswordEyeOpen" onClick={() => setInputType('password')}>{t("login.eyeO")}</a>
                                    ) : (
                                        <a className="showPasswordEye showPasswordEyeClosed" onClick={() => setInputType('text')}>{t("login.eyeC")}</a>
                                    )}
                                    <div className="ReactPasswordStrength passwordStrength">
                                        <input
                                            type={inputType}
                                            className="form-control"
                                            value={password}
                                            placeholder={t("login.newPass")}
                                            onChange={(e) => setPassword(e.target.value)}
                                            autoFocus
                                        />
                                        <PasswordStrengthBar password={password} onChangeScore={(score) => setScore(score)} scoreWords={[t("login.ps1"), t("login.ps2"), t("login.ps3"), t("login.ps4"), t("login.ps5")]} shortScoreWord={t("login.tooS")} />
                                    </div>
                                </div>
                                <div className="col-xs-12 adminLoginSubmit" style={{paddingTop:"25px"}}>
                                    <a onClick={(event) => handleResetPasswordClick(event)}>
                                        {t("login.resPass")}
                                    </a>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
